import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { deactivateRoute } from './../auth-guard/deactivate-route.guard';
import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CommonService } from '../services/common.service';
import { CaseManagementService } from '../services/caseManagement.service';
import { ProfileService } from '../services/profile.service';
import { UserInformationService } from '../services/userInformation.service';
import { LoginService } from '../services/login.service';
import { MessageemitterService } from '../services/messageemitter.service';
import { LocalstorageService } from '../services/localstorage.service';
import { SignupService } from '../services/signup.service';
import { forkJoin } from 'rxjs';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent implements OnInit, deactivateRoute {

  declinedCount = 0;
  customResponse: any;
  loading: boolean = false;
  private rootURL: string = environment.baseUrl;
  customerKey: any;
  companySummaryInformation: any = [];
  private baseUrlAxlePoint: string = environment.baseUrlForAxlePoint;
  companyName: string;
  showButtons: boolean;
  companyDetails: any;
  agreeDate = formatDate(new Date(), 'dd-MM-yyyy', 'en');
  Rate = 65;
  Percentage = 3;
  dateVal = new Date();
  isAgreement: boolean;
  showTermsAndConditions = false;
  agreementPresent = false;

  agreementURL: SafeResourceUrl;
  printBtn = true;

  constructor(
    private router: Router,
    private http: HttpClient,
    private commonService: CommonService,
    private profileService: ProfileService,
    private userInformationService: UserInformationService,
    private loginService: LoginService,
    private localStorageService: LocalstorageService,
    private caseManagementService: CaseManagementService,
    private signupService: SignupService,
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    // this.commonService.checkLoggedInUser();
    this.showButtons = this.caseManagementService.getIsFromVerificationLink() == 'verification' ? true : false;
    this.companyDetails = this.signupService.getCompanyDetails();

    const inviteDataReq = this.signupService.getInvitedCustomer(this.companyDetails.email);
    const userInfoReq = this.userInformationService.getUserInformationByEmail(this.companyDetails.email);
    this.loading = true;
    forkJoin([userInfoReq, inviteDataReq]).subscribe((res: any) => {
      this.loading = false;
      this.companySummaryInformation = res[0];
      sessionStorage.setItem('userName', res[0].email);

      if (res[1].length > 0) {
        this.Rate = res[1][0].Rates ? res[1][0].Rates : this.Rate;
        this.Percentage = res[1][0] ? res[1][0].Percentage : this.Percentage;
      }

      if (this.companySummaryInformation.agreementTemplateURL) {
        this.agreementPresent = true;
        this.showTermsAndConditions = false;
        let url = this.companySummaryInformation.agreementTemplateURL + "#zoom=120";
        this.agreementURL = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
        this.printBtn = false;
      } else {
        this.showTermsAndConditions = true;
      }

    }, (err) => {
      this.loading = false;
      console.error('TermsAndConditionsComponent_ngOnInit', err);
    });
  }

  /*****
  * Accept User terms & conditions
  */
  accept() {
    // this.loading = true;
    this.isAgreement = true;
    this.updateLegecyKey();
  }

  acceptAgreement(subCustomerKey: any) {
    const agreementData = {
      address: this.companySummaryInformation.address + ', ' + this.companySummaryInformation.city + ', ' + this.companySummaryInformation.stateTypeId + ', ' + this.companySummaryInformation.zip,
      companyName: this.companySummaryInformation.companyName,
      customerKey: this.companySummaryInformation.customerUserInformationId,
      date: this.agreeDate,
      namedTitle: this.companySummaryInformation.companyName,
      percentage: this.Percentage + '%',
      woFee: '$' + this.Rate,
      isAgreementAccepted: 1,
      updateAgreement: !this.agreementPresent ? 1 : 0
    }
    this.loading = true;
    this.userInformationService.updateAggregateTemplate(agreementData).subscribe((res) => {
      this.loading = false;
      this.signupService.setIsAgreementAccepted(false);
      const localPassword = localStorage.getItem('localPassword');
      if (this.companySummaryInformation.email != "" && localPassword != null) {
        this.redirectUser(this.companySummaryInformation.email, localPassword, subCustomerKey);
      } else {
        this.loading = false;
        this.router.navigate(['/signup-complete']);
      }
    }, (error) => {
      this.loading = false;
      console.error('TermsAndConditionsComponent_acceptAgreement', error);
    });
  }

  /*****
  * Decline User terms & conditions
  */
  decline() {
    this.isAgreement = true;
    if (confirm("Are you sure you want to decline?")) {
      const data = {
        customerUserInformationID: this.companySummaryInformation.customerUserInformationId, //this.companyDetails.customerUserInformationID,
        parentInfoId: this.companySummaryInformation.customerParentInformationID //this.companyDetails.parentId
      }
      this.loading = true;
      this.http.post(this.rootURL + 'api/customers/deActivateUser', data).subscribe(() => {
        this.loading = false;
      }, (error) => {
        this.loading = false;
        console.error('TermsAndConditionsComponent_decline', error);
      });
      sessionStorage.clear();
      this.router.navigateByUrl('/login');
    }
  }

  updateLegecyKey() {
    const headers = new HttpHeaders({
      token: 'TTNFleet2018'
    });

    const data = {
      'customerName': this.companySummaryInformation.companyName,
      'customerCode': this.companySummaryInformation.companyName,
      'customerTeam': 1,
      'customerMailingAddress': this.companySummaryInformation.address,
      'customerMailingCity': this.companySummaryInformation.city,
      'customerMailingState': this.companySummaryInformation.stateTypeId,
      'customerMailingZip': this.companySummaryInformation.zip,
      'primaryContactName': this.companySummaryInformation.firstname + ' ' + this.companySummaryInformation.lastname,
      'primaryCellPhone': this.companySummaryInformation.cellPhone,
      'primaryContactPhone': this.companySummaryInformation.officePhone,
      'primaryContactEmail': this.companySummaryInformation.email,
      'primaryBillingEmail': this.companySummaryInformation.billingEmail,
      'primaryContactFax': '',
      'inRates': this.Rate,
      'inPercentage': this.Percentage,
      'isApprover': parseInt(this.companySummaryInformation.isApprover),
      'receiveInvoice': parseInt(this.companySummaryInformation.receiveInvoice),
      'receiveBreakdownCommunication': parseInt(this.companySummaryInformation.receiveBreakdownCommunication)
    }

    this.http.post(this.baseUrlAxlePoint + 'api/alxepoint/customer/profile', data, { headers: headers }).subscribe((response: any) => {
      this.customResponse = response;
      if (response.body[0].CustomerKey) {
        const mappingObject = {
          'customerUserInformationId': this.companySummaryInformation.customerParentInformationID,//this.companyDetails.parentId,
          'legacyCustomerKeyId': response.body[0].CustomerKey,
          'fleetCustomerId': response.body[0].FleetCustomerId,
          'subCustomerId': response.body[0].SubCustomerKey
        };

        const legacyMappingReq = this.http.post(this.rootURL + 'api/customers/user/legacyMapping', mappingObject);
        const defaultProtocolReq = this.profileService.getDefaultsProtocolsBeta(response.body[0].CustomerKey);

        this.loading = true;
        forkJoin([legacyMappingReq, defaultProtocolReq]).subscribe(() => {
          this.loading = false;
          this.acceptAgreement(response.body[0].SubCustomerKey);
        }, (error) => {
          this.loading = false;
          console.error('TermsAndConditionsComponent_updateLegecyKey', error);
        });
      }
    }, (error) => {
      this.loading = false;
      console.error('TermsAndConditionsComponent_updateLegecyKey', error);
    });


  }

  redirectUser(uname, pwd, subCustomerId) {
    this.loading = true;
    this.loginService.userAuthentication(uname, pwd).subscribe((response: any) => {
      this.loading = false;
      MessageemitterService.get("loginStatus").emit(['true']);
      this.localStorageService.setAuthorizationData(response);
      sessionStorage.setItem('currentUserEmail', uname);
      sessionStorage.setItem('emailInLocalStorage', uname);
    },
      (err: HttpErrorResponse) => {
        this.loading = false;
        this.router.navigate(['/signup-complete']);
        console.error('TermsAndConditionsComponent_redirectUser', err);
        return;
      }, () => {
        this.loading = true;
        this.userInformationService.getUserInformationByEmail(sessionStorage.getItem("currentUserEmail")).subscribe((res) => {
          this.loading = false;
          const userDetails = {
            'firstname': res.firstname,
            'middlename': res.middlename,
            'lastname': res.lastname,
            'email': res.email,
            'billingEmail': res.billingEmail,
            'phone': res.phone,
            'breakDownPhone': res.officePhone,
            'address': res.address,
            'city': res.city,
            'state': res.stateTypeId,
            'zip': res.zip,
            'isDemoComplete': res.isDemoComplete,
            'subScriptionType': res.subScriptionType,
            'viewProviderInvoice': res.viewProviderInvoice,
          };

          sessionStorage.setItem('userDetails', JSON.stringify(userDetails));
          sessionStorage.setItem('companyName', res.companyName);
          sessionStorage.setItem('customerTimezone', res.timeZoneTypeId == 0 ? "America/New_York" : res.timeZoneTypeId);

          this.customResponse = res;
        }, (err) => {
          this.loading = false;
          console.error('TermsAndConditionsComponent_redirectUser', err);
        },
          () => {
            sessionStorage.setItem('customerUserInformationId', this.customResponse.customerUserInformationId);
            sessionStorage.setItem('legacyCustomerKeyId', this.customResponse.legacyCustomerKeyId);
            sessionStorage.setItem('fleetCustomerId', this.customResponse.fleetCustomerId);
            sessionStorage.setItem('customerParentInformationID', this.customResponse.customerParentInformationID);
            sessionStorage.setItem('userAssociation', this.customResponse.userAssociation);
            sessionStorage.setItem('subCustomerId', subCustomerId);
            sessionStorage.setItem('fleetCustomerId', this.customResponse.fleetCustomerId);
            sessionStorage.setItem('image', this.customResponse.image);
            sessionStorage.setItem('subCustomerId', this.customResponse.legacySubCustomerKey);
            sessionStorage.setItem('doNotShowTour', this.customResponse.doNotShowTour);
            sessionStorage.setItem('approvalAvailabilityStart', this.customResponse.approvalAvailabilityStart);
            sessionStorage.setItem('approvalAvailabilityStop', this.customResponse.approvalAvailabilityStop);
            sessionStorage.setItem('approvalLimitRepairsTow', this.customResponse.approvalLimitRepairsTow);
            sessionStorage.setItem('approvalLimitTire', this.customResponse.approvalLimitTire);
            sessionStorage.setItem('assignedTo', this.customResponse.assignedTo);
            sessionStorage.setItem('available24Hours', this.customResponse.available24Hours);
            sessionStorage.setItem('notAnApprover', this.customResponse.notAnApprover);
            sessionStorage.setItem('weekDay', this.customResponse.weekDay);
            sessionStorage.setItem('title', this.customResponse.title);
            sessionStorage.setItem('hierachy', this.customResponse.hierachy);
            sessionStorage.setItem('view', this.customResponse.view);
            sessionStorage.setItem('role', this.customResponse.role);
            sessionStorage.setItem('loggedInRegionName', this.customResponse.regionName);
            sessionStorage.setItem('loggedInDivisionName', this.customResponse.divisionName);
            sessionStorage.setItem('loggedInLocationName', this.customResponse.locationName);

            sessionStorage.setItem('ersSubcustomerId', this.customResponse.ersSubcustomerId);
            sessionStorage.setItem('ersDivisionId', this.customResponse.ersDivisionId);
            sessionStorage.setItem('ersLocationId', this.customResponse.ersLocationId);
            sessionStorage.setItem('fleetSubcustomerId', this.customResponse.fleetSubcustomerId);
            sessionStorage.setItem('fleetDivisionId', this.customResponse.fleetDivisionId);
            sessionStorage.setItem('fleetLocationId', this.customResponse.fleetLocationId);
            sessionStorage.setItem('agreementURL', this.customResponse.agreementTemplateURL);
            sessionStorage.setItem('subscriptionType', this.customResponse.subScriptionType);
            sessionStorage.setItem('restrictWOsDate', this.customResponse.restrictWOsDate ? this.customResponse.restrictWOsDate : '');
            sessionStorage.setItem('isAgreementAccepted', this.customResponse.isAgreementAccepted);
            this.loading = false;
            this.router.navigate(['/pages']);
          });
      }
    );
  }

  canDeactivate(): boolean {
    if (this.isAgreement) {
      return true;
    } else {
      return confirm('You will not be able to use the services of Client Portal, until the service agreement is accepted');
    }
  }
}
